import { Directive } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';

const SEASON_MMDD_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/dd'
  },
  display: {
    dateInput: { month: '2-digit', day: '2-digit' },
    monthYearLabel: { month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { month: 'long' }
  }
};

@Directive({
  standalone: false,
  selector: '[appSeasonDateFormats]',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: SEASON_MMDD_DATE_FORMATS }]
})
export class SeasonDateFormatsDirective {}
